/* ============================================================
   Category rail: slow, eased scrolling (Blinkit-style)
   ------------------------------------------------------------
   Mouse wheel / trackpad scrolling over the sidebar no longer
   jumps a full notch at a time. Each wheel step sets a target,
   and the rail glides towards it a little every frame, so the
   categories slide down smoothly. When the rail hits its top or
   bottom the wheel goes back to scrolling the page.

   Reach-the-end fix: the rail is a full screen tall but, until
   the page is scrolled, it starts below the header, so its last
   rows sat below the bottom of the screen and could not be
   reached without scrolling the products first. While that part
   of the rail is off-screen, the same amount of room is added to
   the bottom of the rail's scroll range, so every category can
   be scrolled up into view from any page position.

   On load the selected category is gently scrolled into view.
   Phones keep their native touch momentum. Respects
   prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var rail = document.querySelector('.collection-rail');
  if (!rail || rail.getAttribute('data-smooth-rail')) return;
  rail.setAttribute('data-smooth-rail', '1');

  /* Sticky inside a flex row only pins when the rail is not stretched. */
  rail.style.alignSelf = 'flex-start';

  /* ---------- keep the whole list reachable ---------- */
  var basePad = 0;
  var hiddenNow = -1;
  var fitQueued = false;

  function readBasePad() {
    rail.style.paddingBottom = '';
    basePad = parseFloat(window.getComputedStyle(rail).paddingBottom) || 0;
    hiddenNow = -1;
  }

  function lastRow() {
    var kids = rail.children;
    for (var i = kids.length - 1; i >= 0; i--) {
      if (kids[i].offsetHeight) return kids[i];
    }
    return null;
  }

  function fit() {
    fitQueued = false;
    if (rail.hidden || !rail.offsetHeight) return;

    var viewH = window.innerHeight;
    var r = rail.getBoundingClientRect();
    /* how much of the rail's box is below the bottom of the screen */
    var hidden = Math.max(0, Math.ceil(r.bottom - viewH));

    /* No extra room needed when every row already fits in the visible part. */
    var last = lastRow();
    var contentH = last ? last.offsetTop + last.offsetHeight : 0;
    if (contentH + basePad <= rail.clientHeight - hidden) hidden = 0;

    if (hidden === hiddenNow) return;
    hiddenNow = hidden;
    rail.style.paddingBottom = (basePad + hidden) + 'px';
  }

  function queueFit() {
    if (fitQueued) return;
    fitQueued = true;
    window.requestAnimationFrame(fit);
  }

  readBasePad();
  fit();
  window.addEventListener('scroll', queueFit, { passive: true });
  window.addEventListener('resize', function () { readBasePad(); queueFit(); });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', queueFit);
  window.addEventListener('load', queueFit);
  /* The header and banners settle after first paint and push the rail
     down without any scroll, so re-measure whenever the page resizes. */
  if (window.ResizeObserver) new ResizeObserver(queueFit).observe(document.body);
  rail.addEventListener('pointerenter', fit);

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Bring the selected category into view, centred in the visible part of the rail. */
  var active = rail.querySelector('.collection-rail__item.is-active');
  if (active) {
    var r0 = rail.getBoundingClientRect();
    var visibleH = Math.min(rail.clientHeight, window.innerHeight - Math.max(0, r0.top));
    var off = active.offsetTop - (visibleH - active.offsetHeight) / 2;
    if (off > 0) {
      try { rail.scrollTo({ top: off, behavior: reduce ? 'auto' : 'smooth' }); }
      catch (e) { rail.scrollTop = off; }
    }
  }

  if (reduce) return;

  var SPEED = 0.45; /* share of each wheel step that is applied: lower = slower */
  var EASE = 0.08;  /* how much of the remaining distance is covered per frame: lower = longer glide */

  var target = rail.scrollTop;
  var current = rail.scrollTop;
  var raf = null;

  function maxScroll() { return rail.scrollHeight - rail.clientHeight; }

  function step() {
    current += (target - current) * EASE;
    if (Math.abs(target - current) < 0.5) current = target;
    rail.scrollTop = current;
    raf = current === target ? null : window.requestAnimationFrame(step);
  }

  rail.addEventListener('wheel', function (e) {
    if (e.ctrlKey) return; /* pinch-zoom */
    fit();
    var m = maxScroll();
    if (m <= 0) return;

    var dy = e.deltaY;
    if (e.deltaMode === 1) dy *= 16;
    else if (e.deltaMode === 2) dy *= rail.clientHeight;
    if (!dy) return;

    if (!raf) { target = current = rail.scrollTop; }

    /* At either end, let the page scroll instead. */
    if ((dy < 0 && target <= 0) || (dy > 0 && target >= m)) return;

    e.preventDefault();
    target = Math.max(0, Math.min(m, target + dy * SPEED));
    if (!raf) raf = window.requestAnimationFrame(step);
  }, { passive: false });

  /* Touch or scrollbar drags move the rail directly; stay in sync. */
  rail.addEventListener('scroll', function () {
    if (!raf) target = current = rail.scrollTop;
  }, { passive: true });

  rail.addEventListener('touchstart', fit, { passive: true });
})();
